import { render, staticRenderFns } from "./StudentQuotas.vue?vue&type=template&id=6536703e&"
import script from "./StudentQuotas.vue?vue&type=script&lang=js&"
export * from "./StudentQuotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports